import CategoryTiles from "@/components/CategoryTiles.vue";
import * as themeColors from "@assets/styles/colors.module.scss";
import { builderCta } from "@/helpers/builder-init/index";
import { useBuilderShowIf } from "../composables/builderFieldUtility";
import { heroBannerInit } from "@/helpers/builder-init/HeroBanner";
import { useColors } from "@/helpers/composables/useColors";
const { colors } = useColors();
const { hasValue, hasValueEqualTo, hasRichText } = useBuilderShowIf();

let modifiedHeroBannerInputs = JSON.parse(JSON.stringify(heroBannerInit.inputs))
    .filter(section=>(![
        'banner_content',
        'badge',
        'feature_bar'
    ].includes(section.name)));

modifiedHeroBannerInputs.forEach((section,i)=>{
    if(['eyebrow','header'].includes(section.name)){
        let colorSubFieldIndex = section.subFields.findIndex(subField=>subField.name == 'color');
        delete modifiedHeroBannerInputs[i].subFields[colorSubFieldIndex].showIf;
    }
    if('banner_media' == section.name){
        section.subFields = section.subFields.filter((subField)=>{
            return !['min_height','max_height','inset_banner'].includes(subField.name)
        })
    }
})

modifiedHeroBannerInputs = modifiedHeroBannerInputs.filter((section)=>(!['ctas','description'].includes(section.name)));

export const categoryTilesInit = {
    component: CategoryTiles,
    name: "CategoryTiles",
    inputs: [
        {
            name: "button_bg_color",
            friendlyName: "Button Background Color",
            type: "string",
            enum: ['Default', ...Object.keys(colors)],
            default: 'Default'
        },
        {
            name: "button_font_color",
            friendlyName: "Button Font Color",
            type: "string",
            enum: ['Default', ...Object.keys(colors)],
            default: 'Default'
        },
        {
            name: "banner",
            type: "object",
            subFields: [
                ...modifiedHeroBannerInputs
            ]
        }
    ]
};
